import {
	SET_ATTENDEES,
	SET_AUDIT,
	FETCH_EVENT_SYNCS,
	CLEAR_EVENT_SYNCS,
	FETCH_ANNOUNCEMENTS,
	CLEAR_ANNOUNCEMENTS,
	FETCH_POSTS,
	CLEAR_POSTS,
	FETCH_EVENT_MEDIA,
	CLEAR_EVENT_MEDIA,
} from '../actions/actionTypes';

const preState = {
	attendeePageInfo: null,
	attendeeOrder: [],
	auditPageInfo: null,
	eventSyncsPageInfo: {},
	announcementsPageInfo: null,
	postsPageInfo: null,
	mediaPageInfo: null,
	postsMediaCount: null,
};

const contextReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, attendees, audit, eventSyncs, announcements, posts, media } = action;

	switch (type) {
		case SET_ATTENDEES:
			stateDup.attendeePageInfo = attendees.page_info;
			stateDup.attendeeOrder = attendees.nodes.map(({ id }) => id);
			return stateDup;
		case SET_AUDIT:
			stateDup.auditPageInfo = audit.page_info;
			return stateDup;
		case FETCH_EVENT_SYNCS:
			stateDup.eventSyncsPageInfo = eventSyncs.page_info;
			return stateDup;
		case CLEAR_EVENT_SYNCS:
			stateDup.eventSyncsPageInfo = {};
			return stateDup;
		case FETCH_ANNOUNCEMENTS:
			stateDup.announcementsPageInfo = announcements.page_info;
			return stateDup;
		case FETCH_POSTS:
			stateDup.postsPageInfo = posts.page_info;
			stateDup.postsMediaCount = posts.total_media_count;
			return stateDup;
		case CLEAR_POSTS:
			stateDup.postsPageInfo = null;
			stateDup.postsMediaCount = null;
			return stateDup;
		case CLEAR_ANNOUNCEMENTS:
			stateDup.announcementsPageInfo = null;
			return stateDup;
		case FETCH_EVENT_MEDIA:
			stateDup.mediaPageInfo = media.page_info;
			return stateDup;
		case CLEAR_EVENT_MEDIA:
			stateDup.mediaPageInfo = null;
			return stateDup;
		default:
			return state;
	}
};

export default contextReducer;
